module.exports = __webpack_public_path__ + "media/store/images/icon-buttons/plus-095a5a468a10be2dd0140587a94302e6.svg";